import { ArrowRight } from 'lucide-react';
import { buttonVariants } from './ui/Button';
import { useT } from '@/i18n/provider';
import { LocalizedAnchor } from './LocalizedLink';
import { SITE_LOCALE } from '@/lib/site-config';
import { trackEvent } from '@/lib/analytics';

export function CTASection() {
  const t = useT();

  return (
    <section className="py-24 sm:py-32">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="animate-on-scroll max-w-3xl mx-auto text-center">
          <h2 className="font-display text-3xl sm:text-4xl font-bold text-gray-950 dark:text-white tracking-tight text-balance">
            {t('cta.title')}
          </h2>
          <p className="mt-4 text-lg text-gray-600 dark:text-gray-400 max-w-xl mx-auto">
            {t('cta.subtitle')}
          </p>
          <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4">
            <a href="https://app.logpulse.io/sign-up" className={buttonVariants({ variant: 'default', size: 'xl' })}>
              {t('cta.button')}
              <ArrowRight className="h-5 w-5 ml-1" />
            </a>
            {SITE_LOCALE === 'nl' ? (
              <a
                href="https://booking.logpulse.io/"
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => trackEvent('book_demo_click', { surface: 'cta' })}
                className={buttonVariants({ variant: 'outline', size: 'xl' })}
              >
                {t('nav.bookDemo')}
              </a>
            ) : (
              <LocalizedAnchor href="/contact" className={buttonVariants({ variant: 'outline', size: 'xl' })}>
                {t('socialProof.cta')}
              </LocalizedAnchor>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
